import * as _ from 'lodash';
import { Utils } from "../Utils/Utils";
import {WidgetApiBase} from './WidgetBase';

export class MultiSelectApi extends WidgetApiBase {
    private _multiselect: JQuery;

    constructor(id: string) {
        super(id);
    }

    protected getInitOptions(): Object {
        return null;
    }

    protected getMultiselect(doInit: boolean = false): JQuery {
        if (!this._multiselect) {
            var opt = doInit ? this.getInitOptions() : undefined;
            this._multiselect = this.jq.multiselect(opt);
        }
        return this._multiselect;
    }

    protected setOptions(options: any, value?: any): void {
        this.jq.multiselect(options, value);
    }

    public getSelect(): JQuery {
        return this.getMultiselect();
    }

    private getOptions(onlySelected: boolean): { options: Array<HTMLOptionElement>, count: number } {
        var options = $('option', this.getSelect());
        var result: Array<HTMLOptionElement> = [];
        var count = 0;
        options.each((idx: number, option: HTMLOptionElement) => {
            var include = !onlySelected || $(option).is(':selected');
            if (include) {
                result.push(option);
            }
            count++;
        });

        return { options: result, count: count};
    }

    public getAllOptions(): Array<HTMLOptionElement> {
        return this.getOptions(false).options;
    }

    public getSelections(): Array<HTMLOptionElement> {
        return this.getOptions(true).options;
    }

    public getSelectionCount(): number {
        return this.getSelections().length;
    }

    public isAllSelected(): boolean {
        var r = this.getOptions(true);
        return r.options.length === r.count;
    }

    public getSelectionValues(delimiter: string = ';'): string {
        var selection = this.getSelections();
        return selection.length === 0 ? '' : _.map(selection, (x: HTMLOptionElement) => x.value).join(delimiter);
    }

    public setSelectionValues(values: string, delimiter: string = ";"): void {
        this.deselectAll();

        var vals = values.split(delimiter);
        this.setOptions('select', vals);
    }

    public selectAll(): void {
        var options = this.getOptions(false).options;
        var values = _.map(options, (o: HTMLOptionElement) => o.value);
        this.setOptions('select', values);
    }

    public deselectAll(): void {
        var options = this.getOptions(false).options;
        var values = _.map(options, (o: HTMLOptionElement) => o.value);
        this.setOptions('deselect', values);
    }
}

export interface MultiSelectOptions {
    includeSelectAllOption: boolean;
    selectAllNumber: boolean;
    leaveOneSelected: boolean;
    selectAllText: string;
    allSelectedText: string;
    maxHeight?: number;
    numberDisplayed?: number;
    buttonClass?: string;
    checkboxName?: string;
}

export class MultiSelect extends MultiSelectApi {
    private _initialized: boolean;
    private _options: MultiSelectOptions;

    constructor(id: string, options: MultiSelectOptions) {
        super(id);
        this._initialized = false;
        this._options = options;
        this.getMultiselect(true);
    }

    protected getInitOptions(): Object {
        var self = this;
        var o = this._options;
        return {
            includeSelectAllOption: o.includeSelectAllOption,
            selectAllText: o.selectAllText,
            allSelectedText: o.allSelectedText,
            selectAllNumber: o.selectAllNumber,
            maxHeight: o.maxHeight,
            numberDisplayed: o.numberDisplayed,
            buttonClass: o.buttonClass,
            checkboxName: o.checkboxName,

            buttonText: (options: any, select: JQuery): string => {
                var allOptionCount = $('option', select).length;
                var selectedCount = 0;
                $.each(options, (idx: number, opt: HTMLOptionElement) => {
                        if ($(opt).is(':selected')) {
                            selectedCount++;
                        }
                    });

                if (selectedCount === allOptionCount) {
                    return o.allSelectedText;
                }

                return _.map(options, (o: HTMLOptionElement) => o.text).join(',');
            },

            onInitialized: (select: any, container: any) => {
                self._initialized = true;
            },
            onChange: (element: any, checked: boolean) => {
                var selectedCount = self.getSelectionCount();

                if (selectedCount === 0 && self._options.leaveOneSelected && element) {
                    self.setOptions('select', element.val());
                }
            },
            //onDropdownShow: function (event: any) {
            //    var $container = this.$container;
            //    if ($container.parent()[0].tagName !== 'BODY') {
            //        var buttonOffset = this.$button.offset();
            //        $container.remove();
            //        var $body = $(document.body);
            //        $body.append($container);

            //        $container.css('position', 'absolute');
            //        $container.css('top', buttonOffset.top + 'px');
            //        $container.css('left', buttonOffset.left + 'px');
            //    }
            //},
        };
    }
}



/** WEBPACK FOOTER **
 ** ./Typescript/Widgets/MultiSelect.ts
 **/